import React from 'react';
import { Link } from 'react-router-dom';
import { useI18n } from '../../hooks/useI18n';
import { buildLocalizedPath } from '../../seo/urls';

/**
 * SEO-only landing content — rendered in DOM for crawlers, visually hidden from users.
 */
export const LandingSeoContent = () => {
  const { t, language } = useI18n();
  const capabilities = t('seoCapabilities') || [];
  const advantages = t('seoAdvantages') || [];
  const faqItems = t('seoFaq') || [];

  return (
    <div className="sr-only" aria-hidden="true">
      <section aria-labelledby="seo-capabilities-title">
        <h2 id="seo-capabilities-title">{t('seoCapabilitiesTitle')}</h2>
        <p>{t('seoCapabilitiesLead')}</p>
        <div>
          {capabilities.map((item) => (
            <article key={item.title}>
              <h3>{item.title}</h3>
              <p>{item.body}</p>
            </article>
          ))}
        </div>
      </section>

      <section aria-labelledby="seo-advantages-title">
        <h2 id="seo-advantages-title">{t('seoAdvantagesTitle')}</h2>
        <ul>
          {advantages.map((item) => (
            <li key={item}>{item}</li>
          ))}
        </ul>
        <p>
          {t('seoInternalLinksLead')}{' '}
          <Link to={buildLocalizedPath('/about', language)} tabIndex={-1}>
            {t('navAbout')}
          </Link>
          {' '}
          {t('seoInternalLinksAnd')}{' '}
          <Link to={buildLocalizedPath('/pricing', language)} tabIndex={-1}>
            {t('navPricing')}
          </Link>
          .
        </p>
      </section>

      <section aria-labelledby="seo-faq-title">
        <h2 id="seo-faq-title">{t('seoFaqTitle')}</h2>
        <div>
          {faqItems.map((item) => (
            <article key={item.question}>
              <h3>{item.question}</h3>
              <p>{item.answer}</p>
            </article>
          ))}
        </div>
      </section>
    </div>
  );
};
